import { isArray, isArrayBuffer, isPlainObject } from 'lodash';

type TFilesCollection = Record<string, Blob>;

export const extractFiles = (obj: unknown): { cleaned: unknown; files: TFilesCollection } => {
  let files: Record<string, Blob> = {};

  const extractAny = (any: unknown, path: string[]) => {
    if (isPlainObject(any)) {
      return extractObj(any as Record<string, unknown>, path);
    } else if (isArray(any)) {
      return extractArray(any, path);
    } else {
      return any;
    }
  };

  const extractArray = (arr: unknown[], path: string[]) => {
    const newArr: unknown[] = [];
    let key = 0;
    for (const value of arr) {
      const newPath = [...path, `[${key}]`];
      if (value instanceof Blob) {
        files[newPath.join('.')] = value;
      } else {
        newArr.push(extractAny(value, newPath));
      }
      key++;
    }
    return newArr
  };

  const extractObj = (obj: Record<string, unknown>, path: string[]) => {
    const newObj: Record<string, unknown> = {};
    for (const [key, value] of Object.entries(obj)) {
      const newPath = [...path, key];
      if (value instanceof Blob) {
        files[newPath.join('.')] = value;
      } else {
        newObj[key] = extractAny(value, newPath);
      }
    }
    return newObj;
  };

  const cleaned = extractAny(obj, []);

  return { cleaned, files };
};
